import { Controller } from "@hotwired/stimulus"

// The form builder's left-column outline (TASK-267.6).
//
// It renders through :sidebar_left — outside the form-builder controller's
// element, and twice (desktop column + mobile Menu panel) — so it cannot use
// a form-builder action. "+ Add Section" dispatches on window and
// form-builder runs the same create path the canvas's Add Section bar uses.
// The section links are plain in-page anchors; no JS needed for those.
export default class extends Controller {
  addSection(event) {
    event.preventDefault()
    window.dispatchEvent(new CustomEvent("form-outline:add-section"))
  }
}
